import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';

export interface MxAuthenticationService {
    token: string;
    getAuthenticationObsr(): Observable<string | null>;
    authenticate(authParams: { username: string, password: string, 'remember-me': string }): void;
    checkAuth(): Observable<boolean>;
    checkOneLoginEnabled(): Observable<boolean>;
    loggedInUser(): string;
    logOut(message?: string): void;
    invalidateAuth(message: string): void;
    getUserEmail(): Observable<string>;
}
export const MX_AUTHENTICATION_SERVICE_TOKEN = new InjectionToken<MxAuthenticationService>('MX_AUTHENTICATION_SERVICE_TOKEN');
